//
//  DocumentationLegacyPageBlockEmbedYoutube.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { DocumentationLegacyPageBlockEmbedGeneric, } from "./SDKDocumentationLegacyPageBlockEmbedGeneric";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockEmbedYoutube extends DocumentationLegacyPageBlockEmbedGeneric {
}
